import { Box, Button, Fab, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Switch, TextField, Typography } from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
import { getAllOffer } from "./apiFunction";
import Card from "./card";
import CardEle from "./card";
import PopUp from "./PopUp";
import AddIcon from "@mui/icons-material/Add";
import PopUpWp from "./PopUpWp";
import { PaginationCm } from "../../common/pagination";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { Filter } from "../../common/fiterComp";
import PluseIconn from "../../assets/img/icons/plus_icon.png";

export default function ShareMessage() {
  const [numberOfPage, setnumberOfpages] = useState(1)
  const [collection, setColletion] = useState([])
  const fetchAllOffers = () => {
    getAllOffer((data) => {
      console.log("Salon/GetAllOffers ", data?.data?.list);
      setColletion(data?.data?.list || []);
    });
  };


  useEffect(() => {
    fetchAllOffers();
  }, []);
  const [open, setOpen] = useState(false)
  const [opent, setOpent] = useState(false)

  const [getDataPayload, setGetDataPykoad] = useState({
    page: 1,
    pageSize: 1000,
    filter: "",
    search: "",
    filter2: "",
    search2: ""
  })
  const [data, setData] = useState(null)
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Grid
        container
        sx={{
          py: 3,
          px: 3,
          paddingTop: "15px",
          backgroundColor: "#E9E9FF",
          minHeight: "100vh",
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          lg={9}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B", // optional text color
            textAlign: "left",
            marginBottom: "20px",
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "20px",
            fontWeight: 500,
            height: "50px",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              paddingLeft: "10px",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Share Message
          </Typography>
        </Grid>
        <Grid
          item
          lg={3}
          md={4}
          xs={12}
          mb={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: "10px",
          }}
        >
          <Button
            onClick={() => {
              setData(null);
              setOpen(true);
            }}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: "#010093",
              fontWeight: 600,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              display: "flex",
              height: "40px",
              alignItems: "center",
              gap: 2,
              marginBottom: "10px",
            }}
          >
            Add New Message
            <img
              src={PluseIconn}
              alt="plus"
              style={{ width: 18, height: 18 }}
            />
          </Button>
        </Grid>
        {/* <Filter setGetDataPykoad={setGetDataPykoad} getDataPayload={getDataPayload} /> */}
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <Grid
            container
            item
            spacing={1}
            xs={12}
            sx={{
              height: "75vh",
              overflow: "auto",
            }}
          >
            {collection?.map((ele, index) => {
              return (
                <Grid item xs={12} sx={{ paddingRight: "10px" }}>
                  <CardEle
                    item={ele}
                    callback={(data) => {
                      setOpen(true);
                      setData(ele);
                    }}
                    cbt={(data) => {
                      setOpent(true);
                      // setData()
                      setData(ele);
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
          {/* <Grid item xs={12}>
                            <PaginationCm
                                change={()=>{}}
                                />
                        </Grid> */}
        </Grid>
        <PopUp
          open={open}
          setOpen={setOpen}
          data={data}
          refreshOffers={fetchAllOffers}
        />
        <PopUpWp open={opent} setOpen={setOpent} data={data} />
      </Grid>
    </>
  );
}
